import { render, staticRenderFns } from "./EditSeparationRequest.vue?vue&type=template&id=38372983"
import script from "./EditSeparationRequest.vue?vue&type=script&lang=js"
export * from "./EditSeparationRequest.vue?vue&type=script&lang=js"
import style0 from "./EditSeparationRequest.vue?vue&type=style&index=0&id=38372983&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports